/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChallengeResponse
 */
export interface ChallengeResponse {
    /**
     * 
     * @type {string}
     * @memberof ChallengeResponse
     */
    challenge: string;
}

/**
 * Check if a given object implements the ChallengeResponse interface.
 */
export function instanceOfChallengeResponse(value: object): value is ChallengeResponse {
    if (!('challenge' in value) || value['challenge'] === undefined) return false;
    return true;
}

export function ChallengeResponseFromJSON(json: any): ChallengeResponse {
    return ChallengeResponseFromJSONTyped(json, false);
}

export function ChallengeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChallengeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'challenge': json['challenge'],
    };
}

export function ChallengeResponseToJSON(json: any): ChallengeResponse {
    return ChallengeResponseToJSONTyped(json, false);
}

export function ChallengeResponseToJSONTyped(value?: ChallengeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'challenge': value['challenge'],
    };
}

